import { createActionGroup, props } from "@ngrx/store";
import { Contract, CreateContractRequest } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// CONTRACT MANAGEMENT ACTIONS
// Admin CRUD operations for contracts
// Note: Load actions are in entities/contract/contracts
// **************************************************************************
export const ContractManagementActions = createActionGroup({
    source: "Contract Admin / Contract Management",
    events: {
        "Create Contract": props<{ request: CreateContractRequest }>(),
        "Create Contract Success": props<{ contract: Contract; toastKey: string }>(),
        "Create Contract Failure": props<{ error: AppError; toastKey: string }>(),
        "Delete Contract": props<{ id: number }>(),
        "Delete Contract Success": props<{ id: number; toastKey: string }>(),
        "Delete Contract Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
